<div class="dashboard-container">
  <div class="rounded-lg p-1">
    <!-- Company First Card with side margins -->
    <div class="company-first-card mb-4 shadow-lg rounded-lg w-100 px-3 py-2 position-relative" :class="{
    'bolide-bg': hostname.includes('bolide.complyon'),
    'ndabeni-bg': hostname.includes('ndabenitrust.complyon'),
    'x-verdict-bg': hostname.includes('x-verdict'),
    'complyon-bg': hostname.includes('business.complyon') || hostname.includes('complyon.ai') || hostname.includes('aicampus.complyon') ,
    'probaworkflows-bg': hostname.includes('probaworkflows'),
    'trustfirst-bg':hostname.includes('trustfirst.probaanalytics'),
    'rematholdings-bg':hostname.includes('rematholdings.complyon'),
    'dwypd-bg':hostname.includes('monitoring.dwypd.gov.za')
     }">
      <section class="hero-section w-100 px-2 py-1 d-flex justify-content-between align-items-start">

        <!-- Hero content on left -->
        <div class="hero-content p-1 me-5 col-md-7 col-lg-6">
          <h1 class="hero-title text-white text-x fw-bold">
            {{ hostname.includes('x-verdict') ? 'All your case applications, in one place' : 'All your entity applications, in one place' }}
          </h1>
          <p class="hero-description mt-1 text-white text-xs">
           Stay on top of submissions and next steps.
          </p>
        </div>
      </section>
      <div class="d-flex gap-2 justify-content-md-end mt-5">
            <!-- for buttons -->
      </div>
    </div>
  
    <div>
      <!-- Table Card - Responsive by default -->
      <div class="d-flex justify-content-between justify-content-md-start align-items-center mb-3 ">
        <div class="dropdown text-end d-md-none">
          <span
            class="text-dark fw-bold text-xxs cursor-pointer d-inline-flex align-items-center"
            role="button"
            id="assignAdminDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Filter Applications
            <i class="bi bi-caret-down-fill ms-1"></i>
          </span>
          <!-- Dropdown items -->
          <ul class="dropdown-menu dropdown-menu-end mt-1 shadow-sm" aria-labelledby="assignAdminDropdown">
            <li>
              <a class="dropdown-item text-xxs" href="#" @click.prevent="set_status_filter('')">
              </a>
            </li>

            <li v-for="key in DROPDOWN_STATUS_KEYS" :key="key">
              <a class="dropdown-item text-xxs" href="#" @click.prevent="set_status_filter(key)">
                {{ format_status_label(key) }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="shadow-lg bg-white rounded-lg p-3 table-responsive text-xs">
        <table class="table table-hover" id="entity_form_management_table">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Application No</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Entity Name</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Entity Type Name</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in table_safe_application_list" :key="row['Application No']">
              <td class="text-xxs text-start">{{ row['Application No'] }}</td>
              <td class="text-xxs text-start">{{ row['Entity Name'] }}</td>
              <td class="text-xxs text-start">{{ row['Entity Type Name'] }}</td>
              <td class="text-xxs text-start">{{ row['Date Created'] }}</td>
              <td class="text-xxs text-start">{{ row['Status'] }}</td>
              <td>
                <button
                  class="btn btn-primary-dark btn-sm rounded-small shadow text-dark ms-1 text-xxs"
                  @click="view_entity_application_overview(row['Application No'], row['Status'], row._entity_profile_id, row._entity_type_id, row['Entity Name'])"
                >
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <AICampusFooter/>
</div>

